const url = '/income-types';
const Provider = 'IncomeTypes';
const dbModel = 'IncomeTypes';

export { url, Provider, dbModel };
